import React from 'react'


const App = () => {
    return (
		<div className="container">
			<div className="row align-items-center">
				<div className="col-lg-6 col-md-11">
					<div className="about-img ">
						<img src="./photos/about/about-index.jpg" alt="" />
					</div>
				</div>
				<div className="col-lg-6 col-md-12">
					<div className="about-caption">
						<div className="section-tittle section-tittle3 mb-35">
							<h2>WELCOME TO THE PUSHKAR ROUTE</h2>
						</div>
						<p className="mb-30 pera-bottom">The Pushkar Route offers tour with real knowledge of the travellers requirements as well as Customised and tailored trips to suite personal taste,desires.Discover the beautiful bustling streets indulge in the vibrant colours of religion and culture.The Pushkar Route can understand every traveller is unique .Our main endeavours is to show travellers a real India.The Pushkar Route operates more then 10 types of tours.</p>
					</div>
				</div>
			</div>
		</div>	
    );
}

export default App;